// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main Container */
.meetings-container {
  padding: 0;
  background: linear-gradient(135deg, #f1ede2 0%, #e3ddcd 100%);
  min-height: 100vh;
  font-family:
    "Inter",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    sans-serif;
}

/* Hero Banner */
.meetings-hero-banner {
  background: linear-gradient(135deg, #101f38 0%, #0a1628 100%);
  color: white;
  padding: 40px 30px;
  box-shadow: 0 20px 50px rgba(16, 31, 56, 0.15);
}

.hero-content {
  margin-bottom: 30px;
}

.hero-badge {
  display: inline-block;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  padding: 8px 16px;
  border-radius: 50px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin-bottom: 12px;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.hero-content h1 {
  margin: 0 0 10px 0;
  font-size: 36px;
  font-weight: 800;
  letter-spacing: -0.8px;
}

.hero-content p {
  margin: 0;
  font-size: 16px;
  opacity: 0.95;
  max-width: 600px;
}

.hero-stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
}

.hero-stat {
  display: flex;
  align-items: center;
  gap: 16px;
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(10px);
  padding: 16px 20px;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  transition: all 0.3s ease;
}

.hero-stat:hover {
  background: rgba(255, 255, 255, 0.12);
  transform: translateY(-2px);
}

.stat-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.stat-icon.meetings-count {
  background: rgba(198, 161, 91, 0.2);
  color: #c6a15b;
}

.stat-icon.upcoming-count {
  background: rgba(47, 111, 94, 0.2);
  color: #3d8a76;
}

.stat-icon.collected-count {
  background: rgba(28, 58, 99, 0.2);
  color: #1c3a63;
}

.stat-info {
  display: flex;
  flex-direction: column;
}

.stat-label {
  font-size: 12px;
  opacity: 0.85;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.stat-value {
  font-size: 28px;
  font-weight: 800;
}

/* Header */
.meetings-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0;
  padding: 30px;
}

.header-content h2 {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  color: #0a1628;
  letter-spacing: -0.4px;
}

.header-subtitle {
  margin: 8px 0 0 0;
  color: #48546b;
  font-size: 14px;
}

.btn-create-meeting {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: linear-gradient(135deg, #101f38 0%, #132b4d 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 8px 24px rgba(16, 31, 56, 0.25);
}

.btn-create-meeting:hover {
  background: linear-gradient(135deg, #132b4d 0%, #245349 100%);
  box-shadow: 0 12px 32px rgba(16, 31, 56, 0.35);
  transform: translateY(-2px);
}

/* Form Card */
.meeting-form-card {
  background: white;
  padding: 28px;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  margin: 0 30px 30px 30px;
  animation: slideDown 0.3s ease;
  border: 1px solid rgba(16, 31, 56, 0.08);
}

.meeting-form-card h3 {
  margin: 0 0 20px 0;
  font-size: 20px;
  font-weight: 800;
  color: #0a1628;
  background: linear-gradient(135deg, #101f38 0%, #132b4d 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Alerts */
.alert-success,
.alert-error {
  padding: 14px 16px;
  border-radius: 10px;
  margin-bottom: 15px;
  font-size: 14px;
  font-weight: 600;
  border-left: 4px solid;
}

.alert-success {
  background: #e3efe9;
  color: #245349;
  border-left-color: #3d8a76;
}

.alert-error {
  background: #fbeae5;
  color: #8a3322;
  border-left-color: #c9563a;
}

/* Form */
.meeting-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
  font-weight: 600;
  color: #0a1628;
  font-size: 14px;
}

.form-group input,
.form-group select,
.form-group textarea {
  padding: 10px 14px;
  border: 1px solid #e3ddcd;
  border-radius: 6px;
  font-size: 14px;
  font-family: inherit;
  background: white;
  transition: all 0.3s ease;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #2f6f5e;
  box-shadow: 0 0 0 3px rgba(47, 111, 94, 0.1);
}

.form-group select:disabled {
  background: #f1ede2;
  color: #a3abbd;
  cursor: not-allowed;
}

.form-group textarea {
  resize: vertical;
  min-height: 70px;
}

/* Flyer upload */
.flyer-upload-box {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px dashed #d8cfb8;
  border-radius: 12px;
  cursor: pointer;
  overflow: hidden;
  min-height: 160px;
  background: #faf8f2;
  transition: all 0.2s ease;
}

.flyer-upload-box:hover {
  border-color: #2f6f5e;
  background: #f1ede2;
}

.flyer-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #8792a6;
  font-size: 13px;
  padding: 20px;
  text-align: center;
}

.flyer-preview {
  width: 100%;
  max-height: 260px;
  object-fit: cover;
  display: block;
}

/* Form Actions */
.form-actions {
  display: flex;
  gap: 12px;
  margin-top: 10px;
}

.btn-submit,
.btn-cancel {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-submit {
  background: #2f6f5e;
  color: white;
  flex: 1 1;
  justify-content: center;
}

.btn-submit:hover:not(:disabled) {
  background: #245349;
  transform: translateY(-1px);
}

.btn-submit:disabled {
  background: #d8cfb8;
  cursor: not-allowed;
  opacity: 0.7;
}

.btn-cancel {
  background: #f1ede2;
  color: #48546b;
  flex: 1 1;
  justify-content: center;
}

.btn-cancel:hover {
  background: #e3ddcd;
}

/* Loading / Empty States */
.loading-container,
.empty-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
  min-height: 300px;
  margin: 0 30px 30px 30px;
  border: 1px solid rgba(0, 0, 0, 0.04);
}

.loading-container.small,
.empty-container.small {
  margin: 0;
  min-height: 160px;
  padding: 30px 20px;
  box-shadow: none;
  border: none;
}

.spinner {
  animation: spin 1s linear infinite;
  color: #101f38;
  margin-bottom: 15px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading-container p {
  color: #48546b;
  font-size: 14px;
}

.empty-container svg {
  color: #d8cfb8;
  margin-bottom: 15px;
}

.empty-container h3 {
  margin: 0 0 8px 0;
  font-size: 18px;
  color: #0a1628;
}

.empty-container p {
  margin: 0;
  color: #8792a6;
  font-size: 14px;
  text-align: center;
  max-width: 320px;
}

/* Meetings Grid */
.meetings-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 24px;
  padding: 0 30px 30px 30px;
}

/* Meeting Card */
.meeting-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(0, 0, 0, 0.04);
}

.meeting-card.premium:hover {
  box-shadow: 0 16px 40px rgba(16, 31, 56, 0.12);
  transform: translateY(-6px);
  border-color: rgba(16, 31, 56, 0.2);
}

.meeting-flyer-wrap {
  position: relative;
  height: 180px;
  overflow: hidden;
  background: #101f38;
}

.meeting-flyer {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.meeting-flyer-overlay {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 16px;
  background: linear-gradient(180deg, rgba(10, 22, 40, 0) 0%, rgba(10, 22, 40, 0.9) 100%);
}

.meeting-flyer-overlay h3 {
  margin: 0 0 4px 0;
  color: white;
  font-size: 18px;
  font-weight: 800;
  letter-spacing: -0.3px;
}

.meeting-chapter-badge {
  color: #d8e6dd;
  font-size: 12px;
  font-weight: 600;
}

.card-content {
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  color: #48546b;
}

.info-item svg.icon-pin {
  flex-shrink: 0;
  color: #3d8a76;
  stroke-width: 2.5;
}

.card-footer {
  padding: 14px 20px;
  border-top: 1px solid rgba(0, 0, 0, 0.04);
  background: rgba(16, 31, 56, 0.02);
}

.btn-booked-seats {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  border: none;
  cursor: pointer;
  background: linear-gradient(135deg, #101f38, #132b4d);
  color: white;
  transition: all 0.25s ease;
}

.btn-booked-seats:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(16, 31, 56, 0.3);
}

/* Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  animation: fadeIn 0.2s ease-out;
}

.modal-content {
  background: white;
  border-radius: 16px;
  width: 90%;
  max-width: 720px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
  animation: popIn 0.2s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes popIn {
  from {
    transform: scale(0.96);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #eee;
}

.modal-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 800;
  color: #0a1628;
}

.modal-close {
  background: none;
  border: none;
  cursor: pointer;
  color: #48546b;
  display: flex;
  padding: 4px;
  border-radius: 6px;
}

.modal-close:hover {
  background: #f1ede2;
}

.modal-body {
  padding: 8px 24px;
  overflow-y: auto;
  flex: 1 1;
}

.bookings-table-wrap {
  overflow-x: auto;
}

.bookings-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.bookings-table th {
  text-align: left;
  padding: 10px 12px;
  color: #8792a6;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 2px solid #f1ede2;
}

.bookings-table td {
  padding: 12px;
  border-bottom: 1px solid #f1ede2;
  color: #0a1628;
}

.cross-chapter-badge {
  display: inline-block;
  margin-left: 8px;
  padding: 2px 8px;
  border-radius: 999px;
  background: #fff4e0;
  color: #b26a00;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
}

.bookings-table td.mono {
  font-family: "SFMono-Regular", Consolas, monospace;
  font-size: 12px;
  color: #48546b;
}

.modal-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 24px;
  border-top: 1px solid #eee;
  background: rgba(16, 31, 56, 0.02);
  border-radius: 0 0 16px 16px;
}

.modal-footer span {
  font-size: 14px;
  color: #48546b;
  font-weight: 600;
}

.modal-footer strong {
  font-size: 20px;
  color: #101f38;
  font-weight: 800;
}

/* Responsive */
@media (max-width: 768px) {
  .meetings-header {
    flex-direction: column;
    gap: 15px;
    align-items: stretch;
  }

  .btn-create-meeting {
    width: 100%;
    justify-content: center;
  }

  .meetings-grid {
    grid-template-columns: 1fr;
  }

  .form-row {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/admin/components/Meetings.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,UAAU;EACV,6DAA6D;EAC7D,iBAAiB;EACjB;;;;;cAKY;AACd;;AAEA,gBAAgB;AAChB;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qCAAqC;EACrC,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,iDAAiD;EACjD,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA,cAAc;AACd;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,wBAAwB;EACxB,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,WAAW;AACX;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,0BAA0B;AAC5B;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;;EAGE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,SAAO;EACP,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,SAAO;EACP,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,iBAAiB;EACjB,wBAAwB;EACxB,qCAAqC;AACvC;;AAEA;;EAEE,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,iDAAiD;EACjD,aAAa;EACb,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,8CAA8C;EAC9C,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,uFAAuF;AACzF;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,qDAAqD;EACrD,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,2CAA2C;EAC3C,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kDAAkD;EAClD,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* Main Container */\r\n.meetings-container {\r\n  padding: 0;\r\n  background: linear-gradient(135deg, #f1ede2 0%, #e3ddcd 100%);\r\n  min-height: 100vh;\r\n  font-family:\r\n    \"Inter\",\r\n    -apple-system,\r\n    BlinkMacSystemFont,\r\n    \"Segoe UI\",\r\n    sans-serif;\r\n}\r\n\r\n/* Hero Banner */\r\n.meetings-hero-banner {\r\n  background: linear-gradient(135deg, #101f38 0%, #0a1628 100%);\r\n  color: white;\r\n  padding: 40px 30px;\r\n  box-shadow: 0 20px 50px rgba(16, 31, 56, 0.15);\r\n}\r\n\r\n.hero-content {\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.hero-badge {\r\n  display: inline-block;\r\n  background: rgba(255, 255, 255, 0.2);\r\n  backdrop-filter: blur(10px);\r\n  padding: 8px 16px;\r\n  border-radius: 50px;\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n  letter-spacing: 0.08em;\r\n  text-transform: uppercase;\r\n  margin-bottom: 12px;\r\n  border: 1px solid rgba(255, 255, 255, 0.3);\r\n}\r\n\r\n.hero-content h1 {\r\n  margin: 0 0 10px 0;\r\n  font-size: 36px;\r\n  font-weight: 800;\r\n  letter-spacing: -0.8px;\r\n}\r\n\r\n.hero-content p {\r\n  margin: 0;\r\n  font-size: 16px;\r\n  opacity: 0.95;\r\n  max-width: 600px;\r\n}\r\n\r\n.hero-stats-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\r\n  gap: 16px;\r\n}\r\n\r\n.hero-stat {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 16px;\r\n  background: rgba(255, 255, 255, 0.08);\r\n  backdrop-filter: blur(10px);\r\n  padding: 16px 20px;\r\n  border-radius: 16px;\r\n  border: 1px solid rgba(255, 255, 255, 0.15);\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.hero-stat:hover {\r\n  background: rgba(255, 255, 255, 0.12);\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.stat-icon {\r\n  width: 48px;\r\n  height: 48px;\r\n  border-radius: 12px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.stat-icon.meetings-count {\r\n  background: rgba(198, 161, 91, 0.2);\r\n  color: #c6a15b;\r\n}\r\n\r\n.stat-icon.upcoming-count {\r\n  background: rgba(47, 111, 94, 0.2);\r\n  color: #3d8a76;\r\n}\r\n\r\n.stat-icon.collected-count {\r\n  background: rgba(28, 58, 99, 0.2);\r\n  color: #1c3a63;\r\n}\r\n\r\n.stat-info {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.stat-label {\r\n  font-size: 12px;\r\n  opacity: 0.85;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n}\r\n\r\n.stat-value {\r\n  font-size: 28px;\r\n  font-weight: 800;\r\n}\r\n\r\n/* Header */\r\n.meetings-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  margin-bottom: 0;\r\n  padding: 30px;\r\n}\r\n\r\n.header-content h2 {\r\n  margin: 0;\r\n  font-size: 24px;\r\n  font-weight: 700;\r\n  color: #0a1628;\r\n  letter-spacing: -0.4px;\r\n}\r\n\r\n.header-subtitle {\r\n  margin: 8px 0 0 0;\r\n  color: #48546b;\r\n  font-size: 14px;\r\n}\r\n\r\n.btn-create-meeting {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 12px 24px;\r\n  background: linear-gradient(135deg, #101f38 0%, #132b4d 100%);\r\n  color: white;\r\n  border: none;\r\n  border-radius: 10px;\r\n  font-weight: 700;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  box-shadow: 0 8px 24px rgba(16, 31, 56, 0.25);\r\n}\r\n\r\n.btn-create-meeting:hover {\r\n  background: linear-gradient(135deg, #132b4d 0%, #245349 100%);\r\n  box-shadow: 0 12px 32px rgba(16, 31, 56, 0.35);\r\n  transform: translateY(-2px);\r\n}\r\n\r\n/* Form Card */\r\n.meeting-form-card {\r\n  background: white;\r\n  padding: 28px;\r\n  border-radius: 16px;\r\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);\r\n  margin: 0 30px 30px 30px;\r\n  animation: slideDown 0.3s ease;\r\n  border: 1px solid rgba(16, 31, 56, 0.08);\r\n}\r\n\r\n.meeting-form-card h3 {\r\n  margin: 0 0 20px 0;\r\n  font-size: 20px;\r\n  font-weight: 800;\r\n  color: #0a1628;\r\n  background: linear-gradient(135deg, #101f38 0%, #132b4d 100%);\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  background-clip: text;\r\n}\r\n\r\n@keyframes slideDown {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-15px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n/* Alerts */\r\n.alert-success,\r\n.alert-error {\r\n  padding: 14px 16px;\r\n  border-radius: 10px;\r\n  margin-bottom: 15px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  border-left: 4px solid;\r\n}\r\n\r\n.alert-success {\r\n  background: #e3efe9;\r\n  color: #245349;\r\n  border-left-color: #3d8a76;\r\n}\r\n\r\n.alert-error {\r\n  background: #fbeae5;\r\n  color: #8a3322;\r\n  border-left-color: #c9563a;\r\n}\r\n\r\n/* Form */\r\n.meeting-form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 18px;\r\n}\r\n\r\n.form-row {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 18px;\r\n}\r\n\r\n.form-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.form-group label {\r\n  font-weight: 600;\r\n  color: #0a1628;\r\n  font-size: 14px;\r\n}\r\n\r\n.form-group input,\r\n.form-group select,\r\n.form-group textarea {\r\n  padding: 10px 14px;\r\n  border: 1px solid #e3ddcd;\r\n  border-radius: 6px;\r\n  font-size: 14px;\r\n  font-family: inherit;\r\n  background: white;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.form-group input:focus,\r\n.form-group select:focus,\r\n.form-group textarea:focus {\r\n  outline: none;\r\n  border-color: #2f6f5e;\r\n  box-shadow: 0 0 0 3px rgba(47, 111, 94, 0.1);\r\n}\r\n\r\n.form-group select:disabled {\r\n  background: #f1ede2;\r\n  color: #a3abbd;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.form-group textarea {\r\n  resize: vertical;\r\n  min-height: 70px;\r\n}\r\n\r\n/* Flyer upload */\r\n.flyer-upload-box {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border: 2px dashed #d8cfb8;\r\n  border-radius: 12px;\r\n  cursor: pointer;\r\n  overflow: hidden;\r\n  min-height: 160px;\r\n  background: #faf8f2;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.flyer-upload-box:hover {\r\n  border-color: #2f6f5e;\r\n  background: #f1ede2;\r\n}\r\n\r\n.flyer-placeholder {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 8px;\r\n  color: #8792a6;\r\n  font-size: 13px;\r\n  padding: 20px;\r\n  text-align: center;\r\n}\r\n\r\n.flyer-preview {\r\n  width: 100%;\r\n  max-height: 260px;\r\n  object-fit: cover;\r\n  display: block;\r\n}\r\n\r\n/* Form Actions */\r\n.form-actions {\r\n  display: flex;\r\n  gap: 12px;\r\n  margin-top: 10px;\r\n}\r\n\r\n.btn-submit,\r\n.btn-cancel {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 10px 20px;\r\n  border: none;\r\n  border-radius: 6px;\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.btn-submit {\r\n  background: #2f6f5e;\r\n  color: white;\r\n  flex: 1;\r\n  justify-content: center;\r\n}\r\n\r\n.btn-submit:hover:not(:disabled) {\r\n  background: #245349;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.btn-submit:disabled {\r\n  background: #d8cfb8;\r\n  cursor: not-allowed;\r\n  opacity: 0.7;\r\n}\r\n\r\n.btn-cancel {\r\n  background: #f1ede2;\r\n  color: #48546b;\r\n  flex: 1;\r\n  justify-content: center;\r\n}\r\n\r\n.btn-cancel:hover {\r\n  background: #e3ddcd;\r\n}\r\n\r\n/* Loading / Empty States */\r\n.loading-container,\r\n.empty-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 80px 20px;\r\n  background: white;\r\n  border-radius: 16px;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);\r\n  min-height: 300px;\r\n  margin: 0 30px 30px 30px;\r\n  border: 1px solid rgba(0, 0, 0, 0.04);\r\n}\r\n\r\n.loading-container.small,\r\n.empty-container.small {\r\n  margin: 0;\r\n  min-height: 160px;\r\n  padding: 30px 20px;\r\n  box-shadow: none;\r\n  border: none;\r\n}\r\n\r\n.spinner {\r\n  animation: spin 1s linear infinite;\r\n  color: #101f38;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n@keyframes spin {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.loading-container p {\r\n  color: #48546b;\r\n  font-size: 14px;\r\n}\r\n\r\n.empty-container svg {\r\n  color: #d8cfb8;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.empty-container h3 {\r\n  margin: 0 0 8px 0;\r\n  font-size: 18px;\r\n  color: #0a1628;\r\n}\r\n\r\n.empty-container p {\r\n  margin: 0;\r\n  color: #8792a6;\r\n  font-size: 14px;\r\n  text-align: center;\r\n  max-width: 320px;\r\n}\r\n\r\n/* Meetings Grid */\r\n.meetings-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\r\n  gap: 24px;\r\n  padding: 0 30px 30px 30px;\r\n}\r\n\r\n/* Meeting Card */\r\n.meeting-card {\r\n  background: white;\r\n  border-radius: 16px;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);\r\n  overflow: hidden;\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  display: flex;\r\n  flex-direction: column;\r\n  border: 1px solid rgba(0, 0, 0, 0.04);\r\n}\r\n\r\n.meeting-card.premium:hover {\r\n  box-shadow: 0 16px 40px rgba(16, 31, 56, 0.12);\r\n  transform: translateY(-6px);\r\n  border-color: rgba(16, 31, 56, 0.2);\r\n}\r\n\r\n.meeting-flyer-wrap {\r\n  position: relative;\r\n  height: 180px;\r\n  overflow: hidden;\r\n  background: #101f38;\r\n}\r\n\r\n.meeting-flyer {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n\r\n.meeting-flyer-overlay {\r\n  position: absolute;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  padding: 16px;\r\n  background: linear-gradient(180deg, rgba(10, 22, 40, 0) 0%, rgba(10, 22, 40, 0.9) 100%);\r\n}\r\n\r\n.meeting-flyer-overlay h3 {\r\n  margin: 0 0 4px 0;\r\n  color: white;\r\n  font-size: 18px;\r\n  font-weight: 800;\r\n  letter-spacing: -0.3px;\r\n}\r\n\r\n.meeting-chapter-badge {\r\n  color: #d8e6dd;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n}\r\n\r\n.card-content {\r\n  padding: 18px 20px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n\r\n.info-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  font-size: 13px;\r\n  color: #48546b;\r\n}\r\n\r\n.info-item svg.icon-pin {\r\n  flex-shrink: 0;\r\n  color: #3d8a76;\r\n  stroke-width: 2.5;\r\n}\r\n\r\n.card-footer {\r\n  padding: 14px 20px;\r\n  border-top: 1px solid rgba(0, 0, 0, 0.04);\r\n  background: rgba(16, 31, 56, 0.02);\r\n}\r\n\r\n.btn-booked-seats {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n  width: 100%;\r\n  padding: 10px 14px;\r\n  border-radius: 8px;\r\n  font-size: 13px;\r\n  font-weight: 700;\r\n  border: none;\r\n  cursor: pointer;\r\n  background: linear-gradient(135deg, #101f38, #132b4d);\r\n  color: white;\r\n  transition: all 0.25s ease;\r\n}\r\n\r\n.btn-booked-seats:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 8px 20px rgba(16, 31, 56, 0.3);\r\n}\r\n\r\n/* Modal */\r\n.modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(0, 0, 0, 0.45);\r\n  backdrop-filter: blur(4px);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 999;\r\n  animation: fadeIn 0.2s ease-out;\r\n}\r\n\r\n.modal-content {\r\n  background: white;\r\n  border-radius: 16px;\r\n  width: 90%;\r\n  max-width: 720px;\r\n  max-height: 80vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);\r\n  animation: popIn 0.2s ease-out;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes popIn {\r\n  from {\r\n    transform: scale(0.96);\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    transform: scale(1);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.modal-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 20px 24px;\r\n  border-bottom: 1px solid #eee;\r\n}\r\n\r\n.modal-header h2 {\r\n  margin: 0;\r\n  font-size: 18px;\r\n  font-weight: 800;\r\n  color: #0a1628;\r\n}\r\n\r\n.modal-close {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  color: #48546b;\r\n  display: flex;\r\n  padding: 4px;\r\n  border-radius: 6px;\r\n}\r\n\r\n.modal-close:hover {\r\n  background: #f1ede2;\r\n}\r\n\r\n.modal-body {\r\n  padding: 8px 24px;\r\n  overflow-y: auto;\r\n  flex: 1;\r\n}\r\n\r\n.bookings-table-wrap {\r\n  overflow-x: auto;\r\n}\r\n\r\n.bookings-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 13px;\r\n}\r\n\r\n.bookings-table th {\r\n  text-align: left;\r\n  padding: 10px 12px;\r\n  color: #8792a6;\r\n  font-size: 11px;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n  border-bottom: 2px solid #f1ede2;\r\n}\r\n\r\n.bookings-table td {\r\n  padding: 12px;\r\n  border-bottom: 1px solid #f1ede2;\r\n  color: #0a1628;\r\n}\r\n\r\n.cross-chapter-badge {\r\n  display: inline-block;\r\n  margin-left: 8px;\r\n  padding: 2px 8px;\r\n  border-radius: 999px;\r\n  background: #fff4e0;\r\n  color: #b26a00;\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  white-space: nowrap;\r\n}\r\n\r\n.bookings-table td.mono {\r\n  font-family: \"SFMono-Regular\", Consolas, monospace;\r\n  font-size: 12px;\r\n  color: #48546b;\r\n}\r\n\r\n.modal-footer {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 18px 24px;\r\n  border-top: 1px solid #eee;\r\n  background: rgba(16, 31, 56, 0.02);\r\n  border-radius: 0 0 16px 16px;\r\n}\r\n\r\n.modal-footer span {\r\n  font-size: 14px;\r\n  color: #48546b;\r\n  font-weight: 600;\r\n}\r\n\r\n.modal-footer strong {\r\n  font-size: 20px;\r\n  color: #101f38;\r\n  font-weight: 800;\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 768px) {\r\n  .meetings-header {\r\n    flex-direction: column;\r\n    gap: 15px;\r\n    align-items: stretch;\r\n  }\r\n\r\n  .btn-create-meeting {\r\n    width: 100%;\r\n    justify-content: center;\r\n  }\r\n\r\n  .meetings-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .form-row {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
